// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v7.35.1
// source: market_news.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import { PrimaryCompanyIdentifier } from "./security";
import Long from "long";

export const protobufPackage = "com.tick2trade.api.marketnews";

export enum ProviderCode {
  PROVIDER_UNKNOWN = 0,
  ECONOMIC_TIMES = 1,
  MONEY_CONTROL = 2,
  NDTV_PROFIT = 3,
  NSE = 4,
  BSE = 5,
  CNBC = 6,
  UNRECOGNIZED = -1,
}

export function providerCodeFromJSON(object: any): ProviderCode {
  switch (object) {
    case 0:
    case "PROVIDER_UNKNOWN":
      return ProviderCode.PROVIDER_UNKNOWN;
    case 1:
    case "ECONOMIC_TIMES":
      return ProviderCode.ECONOMIC_TIMES;
    case 2:
    case "MONEY_CONTROL":
      return ProviderCode.MONEY_CONTROL;
    case 3:
    case "NDTV_PROFIT":
      return ProviderCode.NDTV_PROFIT;
    case 4:
    case "NSE":
      return ProviderCode.NSE;
    case 5:
    case "BSE":
      return ProviderCode.BSE;
    case 6:
    case "CNBC":
      return ProviderCode.CNBC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ProviderCode.UNRECOGNIZED;
  }
}

export function providerCodeToJSON(object: ProviderCode): string {
  switch (object) {
    case ProviderCode.PROVIDER_UNKNOWN:
      return "PROVIDER_UNKNOWN";
    case ProviderCode.ECONOMIC_TIMES:
      return "ECONOMIC_TIMES";
    case ProviderCode.MONEY_CONTROL:
      return "MONEY_CONTROL";
    case ProviderCode.NDTV_PROFIT:
      return "NDTV_PROFIT";
    case ProviderCode.NSE:
      return "NSE";
    case ProviderCode.BSE:
      return "BSE";
    case ProviderCode.CNBC:
      return "CNBC";
    case ProviderCode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Provider {
  code: string;
  name: string;
  logoUrl: string;
}

export interface NewsArticle {
  providerCode: string;
  title: string;
  summary: string;
  link: string;
  imageUrl: string;
  created: number;
  primaryCompanyIdentifier: PrimaryCompanyIdentifier[];
}

export interface GetMarketNewsRequest {
  pageNumber: number;
  pageSize: number;
  companyCode: string;
  providerCodes: string[];
}

export interface GetMarketNewsResponse {
  newsArticles: NewsArticle[];
  totalCount: number;
}

function createBaseProvider(): Provider {
  return { code: "", name: "", logoUrl: "" };
}

export const Provider = {
  encode(message: Provider, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.code !== "") {
      writer.uint32(10).string(message.code);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.logoUrl !== "") {
      writer.uint32(26).string(message.logoUrl);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Provider {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProvider();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.code = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.logoUrl = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Provider {
    return {
      code: isSet(object.code) ? globalThis.String(object.code) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      logoUrl: isSet(object.logoUrl) ? globalThis.String(object.logoUrl) : "",
    };
  },

  toJSON(message: Provider): unknown {
    const obj: any = {};
    if (message.code !== "") {
      obj.code = message.code;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.logoUrl !== "") {
      obj.logoUrl = message.logoUrl;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Provider>, I>>(base?: I): Provider {
    return Provider.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Provider>, I>>(object: I): Provider {
    const message = createBaseProvider();
    message.code = object.code ?? "";
    message.name = object.name ?? "";
    message.logoUrl = object.logoUrl ?? "";
    return message;
  },
};

function createBaseNewsArticle(): NewsArticle {
  return { providerCode: "", title: "", summary: "", link: "", imageUrl: "", created: 0, primaryCompanyIdentifier: [] };
}

export const NewsArticle = {
  encode(message: NewsArticle, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.providerCode !== "") {
      writer.uint32(18).string(message.providerCode);
    }
    if (message.title !== "") {
      writer.uint32(34).string(message.title);
    }
    if (message.summary !== "") {
      writer.uint32(50).string(message.summary);
    }
    if (message.link !== "") {
      writer.uint32(66).string(message.link);
    }
    if (message.imageUrl !== "") {
      writer.uint32(82).string(message.imageUrl);
    }
    if (message.created !== 0) {
      writer.uint32(96).int64(message.created);
    }
    for (const v of message.primaryCompanyIdentifier) {
      PrimaryCompanyIdentifier.encode(v!, writer.uint32(114).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): NewsArticle {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNewsArticle();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.providerCode = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.title = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.summary = reader.string();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.link = reader.string();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.imageUrl = reader.string();
          continue;
        case 12:
          if (tag !== 96) {
            break;
          }

          message.created = longToNumber(reader.int64() as Long);
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.primaryCompanyIdentifier.push(PrimaryCompanyIdentifier.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NewsArticle {
    return {
      providerCode: isSet(object.providerCode) ? globalThis.String(object.providerCode) : "",
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      summary: isSet(object.summary) ? globalThis.String(object.summary) : "",
      link: isSet(object.link) ? globalThis.String(object.link) : "",
      imageUrl: isSet(object.imageUrl) ? globalThis.String(object.imageUrl) : "",
      created: isSet(object.created) ? globalThis.Number(object.created) : 0,
      primaryCompanyIdentifier: globalThis.Array.isArray(object?.primaryCompanyIdentifier)
        ? object.primaryCompanyIdentifier.map((e: any) => PrimaryCompanyIdentifier.fromJSON(e))
        : [],
    };
  },

  toJSON(message: NewsArticle): unknown {
    const obj: any = {};
    if (message.providerCode !== "") {
      obj.providerCode = message.providerCode;
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.summary !== "") {
      obj.summary = message.summary;
    }
    if (message.link !== "") {
      obj.link = message.link;
    }
    if (message.imageUrl !== "") {
      obj.imageUrl = message.imageUrl;
    }
    if (message.created !== 0) {
      obj.created = Math.round(message.created);
    }
    if (message.primaryCompanyIdentifier?.length) {
      obj.primaryCompanyIdentifier = message.primaryCompanyIdentifier.map((e) => PrimaryCompanyIdentifier.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NewsArticle>, I>>(base?: I): NewsArticle {
    return NewsArticle.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NewsArticle>, I>>(object: I): NewsArticle {
    const message = createBaseNewsArticle();
    message.providerCode = object.providerCode ?? "";
    message.title = object.title ?? "";
    message.summary = object.summary ?? "";
    message.link = object.link ?? "";
    message.imageUrl = object.imageUrl ?? "";
    message.created = object.created ?? 0;
    message.primaryCompanyIdentifier =
      object.primaryCompanyIdentifier?.map((e) => PrimaryCompanyIdentifier.fromPartial(e)) || [];
    return message;
  },
};

function createBaseGetMarketNewsRequest(): GetMarketNewsRequest {
  return { pageNumber: 0, pageSize: 0, companyCode: "", providerCodes: [] };
}

export const GetMarketNewsRequest = {
  encode(message: GetMarketNewsRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.pageNumber !== 0) {
      writer.uint32(8).int32(message.pageNumber);
    }
    if (message.pageSize !== 0) {
      writer.uint32(16).int32(message.pageSize);
    }
    if (message.companyCode !== "") {
      writer.uint32(34).string(message.companyCode);
    }
    for (const v of message.providerCodes) {
      writer.uint32(42).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetMarketNewsRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMarketNewsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.pageNumber = reader.int32();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.pageSize = reader.int32();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.companyCode = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.providerCodes.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMarketNewsRequest {
    return {
      pageNumber: isSet(object.pageNumber) ? globalThis.Number(object.pageNumber) : 0,
      pageSize: isSet(object.pageSize) ? globalThis.Number(object.pageSize) : 0,
      companyCode: isSet(object.companyCode) ? globalThis.String(object.companyCode) : "",
      providerCodes: globalThis.Array.isArray(object?.providerCodes)
        ? object.providerCodes.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: GetMarketNewsRequest): unknown {
    const obj: any = {};
    if (message.pageNumber !== 0) {
      obj.pageNumber = Math.round(message.pageNumber);
    }
    if (message.pageSize !== 0) {
      obj.pageSize = Math.round(message.pageSize);
    }
    if (message.companyCode !== "") {
      obj.companyCode = message.companyCode;
    }
    if (message.providerCodes?.length) {
      obj.providerCodes = message.providerCodes;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMarketNewsRequest>, I>>(base?: I): GetMarketNewsRequest {
    return GetMarketNewsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMarketNewsRequest>, I>>(object: I): GetMarketNewsRequest {
    const message = createBaseGetMarketNewsRequest();
    message.pageNumber = object.pageNumber ?? 0;
    message.pageSize = object.pageSize ?? 0;
    message.companyCode = object.companyCode ?? "";
    message.providerCodes = object.providerCodes?.map((e) => e) || [];
    return message;
  },
};

function createBaseGetMarketNewsResponse(): GetMarketNewsResponse {
  return { newsArticles: [], totalCount: 0 };
}

export const GetMarketNewsResponse = {
  encode(message: GetMarketNewsResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.newsArticles) {
      NewsArticle.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.totalCount !== 0) {
      writer.uint32(24).int32(message.totalCount);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetMarketNewsResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMarketNewsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.newsArticles.push(NewsArticle.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.totalCount = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMarketNewsResponse {
    return {
      newsArticles: globalThis.Array.isArray(object?.newsArticles)
        ? object.newsArticles.map((e: any) => NewsArticle.fromJSON(e))
        : [],
      totalCount: isSet(object.totalCount) ? globalThis.Number(object.totalCount) : 0,
    };
  },

  toJSON(message: GetMarketNewsResponse): unknown {
    const obj: any = {};
    if (message.newsArticles?.length) {
      obj.newsArticles = message.newsArticles.map((e) => NewsArticle.toJSON(e));
    }
    if (message.totalCount !== 0) {
      obj.totalCount = Math.round(message.totalCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetMarketNewsResponse>, I>>(base?: I): GetMarketNewsResponse {
    return GetMarketNewsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetMarketNewsResponse>, I>>(object: I): GetMarketNewsResponse {
    const message = createBaseGetMarketNewsResponse();
    message.newsArticles = object.newsArticles?.map((e) => NewsArticle.fromPartial(e)) || [];
    message.totalCount = object.totalCount ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
